import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';
import config from './src/api/config';

export const app = initializeApp(config.firebaseConfig);

// Region must match where the callables are deployed; defaults to us-central1
// and switches via config when the backend moves to europe-west2.
export const functions = getFunctions(app, config.functionsRegion);
export const db = getFirestore(app);
